import React from 'react';
import { useTranslation } from 'react-i18next';

const CTA = () => {
  const { t,i18n } = useTranslation();

  return (
    <section className="py-6 bg-white dark:bg-Eerie-Black text-Eerie-Black dark:text-white">
        <div className="container mx-auto flex flex-col justify-center p-4 space-y-8 md:p-10 lg:space-y-0 lg:space-x-12 lg:justify-between lg:flex-row">
            <div className={`${i18n.language === 'ar' ? "text-right" : "text-left"} flex flex-col space-y-4 text-center `}>
                <h1 className="text-5xl font-bold leading-none">{t('CTA.title')}</h1>
                <p className="text-lg">{t('CTA.description')}</p>
            </div>
            <div className="flex flex-row items-center self-center justify-center flex-shrink-0 shadow-md lg:justify-end">
                <div className="flex flex-row">
                    <input type="text" placeholder={t('CTA.inputPlaceholder')} className="w-3/5 p-3 ltr:rounded-l-lg rtl:rounded-r-lg sm:w-2/3 " />
                    <button type="button" className="w-2/5 p-3 font-semibold ltr:rounded-r-lg rtl:rounded-l-lg sm:w-1/3 bg-gradient-to-br from-end to-end hover:from-hover-start hover:to-hover-end  active:from-Ripe-mango-light focus:from-Ripe-mango text-gray-900 dark:text-gray-50 focus:border-Ripe-mango-light dark:focus:border-Ripe-mango-light focus:outline-none focus:ring focus:ring-opacity-40 focus:ring-Ripe-mango-light  ">
                      {t('CTA.subscribeButton')}
                    </button>
                </div>
            </div>
        </div>
    </section>
  );
}

export default CTA;
